import { createContext, useContext } from 'react'

export interface DeviceContextValue {
  isMobile: boolean
}

export const DeviceContext = createContext<DeviceContextValue | null>(null)

export function useDevice(): DeviceContextValue {
  const ctx = useContext(DeviceContext)
  if (!ctx) throw new Error('useDevice must be used within DeviceProvider')
  return ctx
}
